const HEX_PREFIX = '\\x';
const UNI_PREFIX = '\\u';
const PAD_CHAR = '0';
const HEX_PAD_LENGTH = 2;
const UNI_PAD_LENGTH = 4;

const hexLookup: { [key: string]: string } = {};
for (let i = 0; i < 256; i += 1) {
  hexLookup[String.fromCharCode(i)] =
    HEX_PREFIX + i.toString(16).padStart(HEX_PAD_LENGTH, PAD_CHAR);
}

export const encodeAsHexOrUnicode = (char: string) =>
  hexLookup[char] ??
  UNI_PREFIX +
    char.codePointAt(0)!.toString(16).padStart(UNI_PAD_LENGTH, PAD_CHAR);

/**
 * Replaces all non-alphanumeric characters with the unicode representation
 * formatted as \xHH \uHHHH. This adheres to the OWASP recommendation for
 * escaping a quoted javascript string.
 *
 * @param {string} str
 * @return {string}
 */
export const escapeJSString = (str: string): string =>
  str.replace(/[^0-9A-Za-z]/gm, encodeAsHexOrUnicode);
